import React from 'react';
import ReactDOM from 'react-dom'
import Header from '../../component/header'
import ProductMedia from '../../component/productMedia'
import Product from '../../component/product'
import GTip from '../../component/gTip'
import FloatMenu from '../../component/floatMenu'
import ProductSet from './component/productSet'
import { AppContext, defaultState } from '../../config/context'
import '../../common/util/channel'
import '../../common/util/polyfill'
import initReportEnv from '../../common/util/report'

initReportEnv('商品详情')

class App extends React.Component {
    constructor() {
        super()
        this.updateUserInfo = user => {
            this.setState(state => ({
                user: {
                    ...state.user,
                    ...user
                }
            }))
        }
        this.state = {
            ...defaultState,
            updateUserInfo: this.updateUserInfo
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <ProductSet></ProductSet>
            <Header></Header>
            <ProductMedia></ProductMedia>
            <Product></Product>
            <GTip></GTip>
            <FloatMenu></FloatMenu>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))